import { render, staticRenderFns } from "./dataRow.vue?vue&type=template&id=ed701a6c&scoped=true&"
import script from "./dataRow.vue?vue&type=script&lang=js&"
export * from "./dataRow.vue?vue&type=script&lang=js&"
import style0 from "./dataRow.vue?vue&type=style&index=0&id=ed701a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed701a6c",
  null
  
)

export default component.exports